export default "__VITE_ASSET__Dvyrzpbm__"